module.exports = __webpack_public_path__ + "static/img/certificate-file.8fa4974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/certificate-file.svg
// module id = /WWS
// module chunks = 0